import React, {Component} from 'react';
import * as R from 'ramda';

import AuthenticatePlatform from './components/views/authenticate';
import CreatePin from './components/views/create_pin';
import CreateBoard from './components/views/create_board';
import SelectPlatformAndPublish from './components/views/select_platform_and_publish';

export const VIEWS = {
    AUTHENTICATE: 'authenticate_platform',
    CREATE_PIN: 'create_pin',
    CREATE_BOARD: 'create_board',
    SELECT: 'select_platform_and_format'
};

const VIEW_STRATEGIES = {
    [VIEWS.AUTHENTICATE]: AuthenticatePlatform,
    [VIEWS.CREATE_PIN]: CreatePin,
    [VIEWS.CREATE_BOARD]: CreateBoard,
    [VIEWS.SELECT]: SelectPlatformAndPublish
};

export default class AdModeInfo extends Component {
    constructor() {
        super();

        this.state = {view: VIEWS.SELECT};
    }

    /**
     * @param {Function} pathFn
     * @memberof AdModeInfo
     */
    getPropForPath = pathFn => pathFn(this.props);

    propPaths = {
        post_id: R.path(['post', 'post_id']),
        pinterest_auth_url: R.path(['shareOptions', 'pinterest_ads', 'verify_url'])
    };

    /**
     * @param {string} nextView
     * @param {*} [nextState={}]
     * @memberof AdModeInfo
     */
    changeView = (nextView, nextState = {}) => {
        this.setState({
            view: nextView,
            ...nextState
        });
    };

    generatePropsForView = () => ({
        ...this.props,

        post_id: this.getPropForPath(this.propPaths.post_id),
        auth_urls: {
            pinterest: R.pipe(
                this.getPropForPath,
                R.ifElse(
                    R.isNil,
                    R.always('#'),
                    R.replace('__POST_ID__', this.getPropForPath(this.propPaths.post_id))
                )
            )(this.propPaths.pinterest_auth_url)
        },

        handleChangeView: (nextView, data) => this.changeView(nextView, data),
        handleCancelAuthenticate: () => this.changeView(VIEWS.SELECT),
        handleCancelBoard: () => this.changeView(VIEWS.SELECT),
        handleCreateBoard: board =>
            this.props.handleCreatePinterestBoard(board, boardId =>
                this.changeView(VIEWS.CREATE_PIN, {boardId})
            ),
        handleCancelPin: () => this.changeView(VIEWS.SELECT),
        handleCreatePin: pin => this.props.handleShareToPinterest(this.state.boardId, pin)
    });

    render() {
        const View = R.prop(this.state.view, VIEW_STRATEGIES);
        return (
            <div className="ad-mode-info">
                <View {...this.generatePropsForView()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/ad_mode_info/index.js